import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../../domain/model/service/local-storage.service';
import { AccountService } from '../../../../domain/service/accountService';


@Component({
  selector: 'app-restore-password',
   templateUrl: './restore-password.component.html',
  styleUrl: './restore-password.component.css'
})
export class RestorePasswordComponent {
  constructor(private readonly router: Router,
    private readonly localStorage: LocalStorageService,
    private readonly accountService: AccountService) {
}
emailFormControl = new FormControl('', [
  Validators.required,
  Validators.email,
]);
  
  resetPassword() {
  let email = this.emailFormControl.value??'';
  
  this.accountService.generateCode(email);
  this.router.navigate(['/codeVerification', email]); 
  }

  backToLogin(){
    this.router.navigate(['/login']); 
  }
}
